import { queryOptions } from '@tanstack/react-query'
import customReportQueryKeys from '../customReportQueryKeys'
import { fetchCustomReportQuery } from '../../service/customReportService'

export const customReportOptions = (id?: number, companyId = '') => {
  return queryOptions({
    queryKey: customReportQueryKeys.detail(companyId, id),
    queryFn: fetchCustomReportQuery,
    enabled: !!companyId && !!id
  })
}
